const routes = {
  admin: '/admin',
  home: '/home',
  teams: '/teams',
  team: (teamRef: string) => `/teams/${teamRef}`,
  portals: '/interventions',
  login: '/login',
  register: '/register',
  pricing: '/pricing',
  pricingCredits: '/pricing/credits',
  contacts: '/contacts',
  statistics: '/statistics',
  procedures: '/procedures',
  adminPricing: '/admin/pricing',
  profile: '/profile',
  myRequests: '/my-requests',
  assistantsForClients: (assistantRef?: string) => (assistantRef ? `/entry-points/${assistantRef}` : '/entry-points'),
  personalAssistant: '/assistant',
  knowledgeBase: '/knowledge-base',
  reportTemplates: '/report-templates',
  assistantsCreate: '/entry-points/create',
  portal: (portalRef: string, token?: string | null) =>
    token ? `/i/${portalRef}?t=${token}` : `/console?portalRef=${portalRef}`,
  teamReport: (shortId: string) => `/team-reports/${shortId}`,
  console: (portalRef?: string, reportId?: string, startLive?: boolean) =>
    portalRef
      ? `/console?portalRef=${portalRef}${reportId ? `&reportId=${reportId}` : ''}${startLive ? '&startLive=true' : ''}`
      : '/console',
  chunks: '/chunks',
  subscription: '/subscription',
}

export default routes
